import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import apiClient from "../../services/apiClient";
import { IMAGE_PATH } from "../../utils/constants";

const HomeBanner = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [desktopBanners, setDesktopBanners] = useState([]);
  const [mobileBanners, setMobileBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch banner data from API
  const fetchBannerData = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/website-images");
      // console.log(response.data)
      if (response.data) {
        setDesktopBanners(response.data.desktop_banners || []);
        setMobileBanners(response.data.mobile_banners || []);
      }
    } catch (error) {
      console.error("Failed to fetch banner data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBannerData();
  }, []);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Get appropriate banners based on device
  const getBanners = () => {
    if (isMobile) {
      return mobileBanners.length > 0 ? mobileBanners : desktopBanners;
    }
    return desktopBanners.length > 0 ? desktopBanners : mobileBanners;
  };

  const banners = getBanners();

  // Fallback banners if no banners are available
  const fallbackDesktopBanners = [
    "https://vskfortrial.xkeiwellness.com/assets/slider-1-Cb5bjdma.jpg",
    "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1920&q=80",
    "https://images.unsplash.com/photo-1594737625785-c7c11f7d7d11?auto=format&fit=crop&w=1920&q=80",
  ];

  const fallbackMobileBanners = [
    "https://vskfortrial.xkeiwellness.com/assets/slider-1-Cb5bjdma.jpg",
    "https://images.unsplash.com/photo-1579758629938-03607ccdbaba?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1593079831268-3381b0db4a77?auto=format&fit=crop&w=800&q=80",
  ];

  // Use fallback if no banners available
  const finalBanners = banners.length > 0 
    ? banners 
    : (isMobile ? fallbackMobileBanners : fallbackDesktopBanners);
  console.log(banners)
  // Skeleton Loading Component
  const BannerSkeleton = () => (
    <div id="HomeBanner" className={`${isMobile ? "mobileBanner" : "desktopBanner"} skeleton-banner`}>
      <div className="skeleton-slider">
        <div className="skeleton-image"></div>
      </div>
    </div>
  );

  if (loading) {
    return <BannerSkeleton />;
  }

  return (
    <div id="HomeBanner" className={isMobile ? "mobileBanner" : "desktopBanner"}>
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        autoplay={{ delay: 4000 }}
        loop={finalBanners.length > 1}
        className="homeBannerSwiper"
      >
        {finalBanners.map((banner, index) => (
          <SwiperSlide key={index}>
            <div className="imageBox">
              <img
                src={IMAGE_PATH + banner.url}
                alt={`banner-${index}`}
                
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeBanner;